<template>
  <div class="feed-back-box">
    <div class="feed-back-data">
      <form action="">
        <div class="person-type">
          <p><label for="categoryId">选择问题类型<i>*</i></label></p>
          <p>
              <span
                  :class="{ 'box-active': tab.id === sortKey }"
                  v-for="(tab, index) in typeList"
                  :key="index"
                  @click="handleSortActive(tab.id)"
              >{{ tab.title }}</span>
          </p>
          <div class="person-info">
            <div >
              <p><label for="contact">问题课程<i>*</i></label> </p>
              <p><a-input id="contact" type="text" autocomplete="off" v-model="form.title" placeholder="请输入课程标题"/></p>
            </div>

            <div>
              <p><label for="contact">联系方式</label></p>
              <p><a-input id="contact" type="text" autocomplete="off" v-model="form.contact"  placeholder="手机号、QQ、邮箱以便我们回复您"/></p>
            </div>
          </div>
          <div class="person-content">
            <p><label for="con">问题描述<i>*</i></label></p>
            <p>
            <a-textarea
                id="textarea"
                type="text"
                autocomplete="off"
                v-model="form.content"
            >
            </a-textarea>
<!--              <a-upload-->
<!--                  name="file"-->
<!--                  :before-upload="beforeUpload"-->
<!--                  :data="uploadData"-->
<!--                  @change="handleChange"-->
<!--              >-->
<!--                <a-button>-->
<!--                  <img class="label-image" src="@/assets/img/cat-tem.png" @click="getImage" v-if="picter.length<3"/>-->
<!--                </a-button>-->
<!--              </a-upload>-->

            </p>
          </div>

          <p>
            <button class="submitSend" @click="handleSend">确定</button>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {getfeedBackCategory,feedBackSubmit} from "@/api/Home";

export default {
  name: "FeedBack",
  components: {},
  data() {
    return {
      sortKey: 0,
      typeList: [],
      picter: [],
      form: {
        categoryId: 0,
        contact: '',
        content: '',
        courseId: '',
        imageUrl: '',
        title: '',
      },
    };
  },
  mounted() {
    this.handleSortActive(0);
    this.categoryMethod()
  },
  methods: {
    // 问题列表
    categoryMethod() {
      getfeedBackCategory({}).then(res => {
        if (res.status == 200) {
          this.typeList = res.data
        }
      })
    },
    handleSortActive(index) {
      this.sortKey = index;
      this.form.categoryId=index;
    },
    // 上传图片
    getImage() {

    },
    handleSend() {
      if(!this.form.content){
        this.$message.error('请描述问题')
        return
      }
      this.form.imageUrl=this.picter.join(',');
      feedBackSubmit(this.form)
          .then((res) => {
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
    },
  }
}
</script>

<style lang="scss">
.feed-back-box {
  padding-top: 8px;
  i{color: #df7645;}
  .feed-back-data {

    form {
      margin: 0 auto;
      width: 100%;
      display: flex;
      justify-content: space-between;

      p {
        margin: 5px 0;
      }

      label {
        font-size: 15px;
        height: 41px;
        line-height: 41px;
        color: #333333;
      }

      input,
      textarea {
        box-sizing: border-box;
        border: 1px solid #d7d7d7;
        margin-bottom: 10px;
        text-indent: 0px;
      }

      .person-type {
        width: 100%;
        p{
          span {
            color: #333;
            border-radius: 5px;
            border:1px solid #DDDDDD;
            margin: 5px 11px 15px 0;
            padding: 3px 15px;
            flex-grow: 1;
            font-size: 15px;
            background: #ffffff;
          }
          .box-active {
            background: #DDDDDD;
          }
        }
      }
      .person-info {
        //width: 100%;
        margin-top: 10px;
        display: flex;
        p {
          color: #333;
          border-radius: 5px;
          padding: 3px 10px 0px 0;
          flex-grow: 1;
          font-size: 15px;
          background: #ffffff;
          input{
            width: 400px;
            height: 40px;
            border-radius: 3px;
          }
        }

      }
      .person-content {
        width: 100%;
        p {
          color: #333;
          border-radius: 5px;
          flex-grow: 1;
          font-size: 15px;
          background: #ffffff;
          input{
            width: 380px;
            height: 25px;
            border-radius: 3px;
            margin-bottom: 10px;
          }
          textarea{
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .label-image{
              width: 45rpx;
              height: 45rpx;
            }
          }
        }

      }
      .submitSend{
        margin: 0 40%;
        width: 64px;
        height: 36px;
        background: #df7645;
        color: #ffffff;
        border-radius: 2px;
        border: #df7645 3px solid;
      }
      #textarea {
        width: 900px;
        height: 220px;
        margin-bottom: 10px;
        resize: none;
      }

      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #d7d7d7;
      }

      input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #d7d7d7;
      }

      input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #d7d7d7;
      }

      input:-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #d7d7d7;
      }
    }
  }
}
</style>
